import { Component, TemplateRef, contentChild, input, model, output } from '@angular/core';

@Component({
  selector: 'app-primeng-multiselect',
  templateUrl: './primeng-multiselect.component.html',
  styleUrls: ['./primeng-multiselect.component.scss'],
  standalone: false,
})
export class PrimengMultiSelectComponent {
  value = model<any[]>([]);
  options = input<any[]>([]);
  optionLabel = input<string>('label');
  optionValue = input<string>('value');
  placeholder = input<string>('Select options');
  disabled = input<boolean>(false);
  filter = input<boolean>(true);
  showClear = input<boolean>(false);
  appendTo = input<string>('body');
  styleClass = input<string>('');
  maxSelectedLabels = input<number>(3);
  selectedItemsLabel = input<string>('{0} items selected');
  display = input<'comma' | 'chip'>('comma');
  emptyMessage = input<string>('No results found');
  emptyFilterMessage = input<string>('No results found');
  size = input<'small' | 'large' | undefined>(undefined);
  loading = input<boolean>(false);
  selectionLimit = input<number | undefined>(undefined);

  onChange = output<any>();
  onClear = output<void>();

  /** Custom item template: <ng-template #multiSelectItem let-item>...</ng-template> */
  itemTemplate = contentChild<TemplateRef<any>>('multiSelectItem');

  handleChange(event: any) {
    // event.value is the updated array from PrimeNG's onChange (respects optionValue).
    // Unwrap object options so page filter state only ever holds primitives.
    const unwrapped = PrimengMultiSelectComponent.unwrapOptions(event.value);
    this.value.set(unwrapped);
    this.onChange.emit(event);
  }

  handleClear() {
    this.value.set([]);
    this.onClear.emit();
  }

  /** Maps object options down to their optionValue / label, leaving primitives untouched. */
  private static unwrapOptions(value: any): any[] {
    if (!Array.isArray(value)) return [];
    return value.map(item => {
      if (!item || typeof item !== 'object' || item instanceof Date) return item;
      return item['value'] ?? item['label'] ?? item['name'] ?? item;
    });
  }
}
